import { render, staticRenderFns } from "./setmeal.vue?vue&type=template&id=5c534b28&"
import script from "./setmeal.vue?vue&type=script&lang=js&"
export * from "./setmeal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c534b28')) {
      api.createRecord('5c534b28', component.options)
    } else {
      api.reload('5c534b28', component.options)
    }
    module.hot.accept("./setmeal.vue?vue&type=template&id=5c534b28&", function () {
      api.rerender('5c534b28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotSetting/setmeal/setmeal.vue"
export default component.exports